import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Container } from "./styles";
import classNames from "classnames";
import PurchasePacks from "../../PurchasePacks";
import { useAppStore } from "../../../stores/appStore";
import { isDarkMode } from "../../../Utils";
import { sendAppEvent } from "../../../Utils";
import { getQuotaZeroMessage } from "./getQuotaZeroMessage";

const QuotaZeroCTA = ({ subscription, quotaLimit = 0, nonZeroMessage, userData }) => {
  const history = useHistory();
  const [openPackModal, setOpenPackModal] = useState(false);

  // for new SW 2.0 styling, remove when we switch
  const isSW2 = useAppStore((state) => state.isSW2);

  let coinsURL = useRef("/assets/pricing/wordcoin.png");

  useEffect(() => {
    coinsURL.current = isDarkMode(userData?.data?.theme) ? "/assets/pricing/wordcoin-shadowless.png" : "/assets/pricing/wordcoin.png";
  }, [userData?.data?.theme]);

  if (!subscription || !subscription.usesQuota) {
    return null;
  }

  const plan = subscription.currentPlan;

  const unclaimedGrace = !subscription.data.grace && subscription.data.graceAmount > 0;
  const proPlus = !subscription.activeTrial && subscription.currentPlan?.price === 9900;
  const isMaxPlan = plan && !subscription.plans.some((p) => p.price > plan.price); // TODO: is this a bug? does not detect Max plan
  const isMaxPlan2 = plan && plan.title === "Max";

  // we show the better plan message when they are on a legacy plan but we are offering them the v3 plans
  const showBetterPlanMessage = plan && (plan.version[0] === "1" || plan.version[0] === "2") && subscription.isV3;

  if (subscription.totalQuota > quotaLimit) {
    return null;
  }

  // If they have grace left, then we don't show
  if (unclaimedGrace) {
    return null;
  }

  let type;

  if (subscription.activeTrial) {
    type = "trial_used_up";
  } else if (isMaxPlan || isMaxPlan2) {
    if (subscription.canPurchasePacks) {
      type = "packs_only";
    } else {
      return null;
    }
  } else {
    if (subscription.canPurchasePacks) {
      type = "upgrade_and_packs";
    } else {
      type = "upgrade_only";
    }
  }

  const showCoins = type === "upgrade_and_packs" || type === "packs_only";
  const consumable = subscription.usesLedgers ? "credits" : "AI words";

  const message = getQuotaZeroMessage(type, consumable, {
    showBetterPlanMessage,
    planTitle: plan?.title,
    totalQuota: subscription.totalQuota,
    nonZeroMessage,
  });

  // SW-8538 Phase B: push /app/plans directly. The Pricing page handles
  // EU-vs-non-EU routing (and opens the VAT modal for EU + !hasPaid users).
  const handleUpgradeClick = () => {
    sendAppEvent("Quota Subscribe Clicked", {
      ref: "quota",
      quota_type: type,
    });

    history.push("/app/plans?ref=quota");
  };

  return (
    <>
      {openPackModal && (
        <PurchasePacks
          subscription={subscription}
          close={() => setOpenPackModal(false)}
        />
      )}

      <Container className={classNames({ noCoins: !showCoins, "show-coins": showCoins, sw2: isSW2 })}>
        <div className={"left-container"}>
          {showCoins && <img src={coinsURL.current} />}

          {message && (
            <p>
              {message.bold && <strong>{message.bold}</strong>}{message.bold ? " " : ""}{message.text}
            </p>
          )}
        </div>

        <div className={classNames("buttons-container", { sw2: isSW2 })}>
          {(type === "packs_only" || type === "upgrade_and_packs") && (
            <button
              onClick={(e) => {
                setOpenPackModal(true);
              }}
              className={classNames({ secondary: type !== "packs_only" })}
            >
              Purchase {consumable}
            </button>
          )}

          {type !== "packs_only" && (
            <button
              onClick={handleUpgradeClick}
            >
              {type === "trial_used_up" ? "Subscribe" : "Upgrade"}
            </button>
          )}
        </div>
      </Container>
    </>
  );
};

export default QuotaZeroCTA;
